import { gql } from '@apollo/client'

export const SUB_SECTORS_RATING = gql`
  subscription sectorsRating {
    sectorsRating {
      timestamp
      data {
        sector
        rating
        rank
      }
    }
  }
`

export const SUB_STOCKS_RATING = gql`
  subscription stocksRating {
    stocksRating {
      timestamp
      data {
        code
        rank
        sector
        totalPoints
      }
    }
  }
`
